export const stripTags = (value: string) => {
  const RE_HTML_TAGS = /(<!--.*?-->|<[^>]*>)/g;
  return value.replace(RE_HTML_TAGS, "");
};
